import { Link } from 'react-router-dom';
import Logo from './Logo';
import { EGRAHMANTREE_URL, NAV_PRODUCT_LINKS, PRODUCTS, SITE } from '../config/site';

export default function Footer() {
  const year = new Date().getFullYear();
  const flagship = PRODUCTS.find((p) => p.isFlagship);

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__top">
          <div className="site-footer__brand">
            <Logo size={48} />
            <p>
              Enterprise software for IoT, telecom, and network operations — engineered in Jaipur, India.
            </p>
            <p className="site-footer__domain">{SITE.domain}</p>
          </div>
          <div>
            <p className="site-footer__title">Platforms</p>
            <ul className="footer-links">
              {NAV_PRODUCT_LINKS.map((item) => (
                <li key={item.path}>
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="site-footer__title">Company</p>
            <ul className="footer-links">
              <li><Link to="/products">All products</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/demo">Request demo</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              {flagship && (
                <li>
                  <a href={EGRAHMANTREE_URL} target="_blank" rel="noopener noreferrer">
                    {flagship.name} ↗
                  </a>
                </li>
              )}
            </ul>
          </div>
          <div>
            <p className="site-footer__title">Contact</p>
            <ul className="footer-links">
              <li><a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
              <li><a href={`tel:${SITE.phoneTel}`}>{SITE.phoneDisplay}</a></li>
              <li>{SITE.location}</li>
              <li>{SITE.businessHours}</li>
            </ul>
          </div>
        </div>
        <div className="site-footer__bottom">
          <span>© {year} {SITE.legalName}. All rights reserved.</span>
          <span>{SITE.domain}</span>
        </div>
      </div>
    </footer>
  );
}
